import { Outlet } from "react-router-dom";
import { RoomTypesList } from "./RoomTypeList";
import RoomTypeForm from "./RoomTypeForm";

export const roomTypesRoutes = [
  {
    path: "room-types",
    element: Outlet,
    children: [
      {
        path: "",
        element: RoomTypesList,
      },
      {
        path: "add",
        element: RoomTypeForm,
      },
      {
        path: "edit/:id",
        element: RoomTypeForm,
      },
    ],
  },
];
